<template>
  <div>
    <!-- 卷 -->
    <div class="volumes">
      <Row :gutter="10">
        <Col span="4">
          <Button
            type="primary"
            @click="handleShowAdd"
            v-hasPermission="[
              'permissionsConfigurationManagement:resourcePermission:add_disc'
            ]"
            >{{
              $t("permission_configuration_management.group.addVolume")
            }}</Button
          >
        </Col>
      </Row>
    </div>
    <Modal
      v-model="modal"
      :title="$t('permission_configuration_management.group.addVolume')"
      width="75%"
      :loading="modalLoading"
      :mask-closable="false"
      :closable="false"
    >
      <Form
        :model="volumeForm"
        :label-width="100"
        ref="volumeForm"
        :rules="ruleValidate"
      >
        <!-- 搜索 -->
        <Row :gutter="16">
          <!-- 云平台 -->
          <!-- <Col span="4">
                        <FormItem :label="$t('permission_configuration_management.group.cloudPlatform')" prop="accountTypeSearchKey" :label-width="60">
                            <Select v-model="volumeForm.accountTypeSearchKey" filterable @on-change="changeAccountTypeSearchKey(volumeForm.accountTypeSearchKey)" :transfer="true" placeholder="">
                                <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col> -->
          <Col span="6">
            <!-- 账户 -->
            <FormItem
              :label="$t('permission_configuration_management.group.account')"
              prop="account"
              :label-width="50"
            >
              <Select
                v-model="volumeForm.account"
                @on-change="changeAccount(volumeForm.account)"
                multiple
                :max-tag-count="1"
                :transfer="true"
                placeholder=""
              >
                <Checkbox
                  v-model="singleAccount"
                  @on-change="selectAccountAll"
                  style="display: block;text-align:right;"
                  >{{ $t("alarms.common.allSelected") }}</Checkbox
                >
                <Option
                  :value="item.id"
                  v-for="(item, index) in accountList"
                  v-bind:key="index"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6" style="z-index: 200">
            <!-- 存储区域 -->
            <FormItem
              :label="$t('permission_configuration_management.group.region')"
              prop="region"
              :label-width="50"
            >
              <Select
                @on-change="changeRegion(volumeForm.region)"
                v-model="volumeForm.region"
                :transfer="true"
                placeholder=""
              >
                <Option
                  :value="item.name"
                  v-for="item in regionList"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <!-- 标签 -->
            <FormItem
              :label="$t('permission_configuration_management.group.tags')"
              prop="tags"
              :label-width="40"
            >
              <Input v-model="volumeForm.tags" placeholder="" />
            </FormItem>
          </Col>
          <Button
            type="primary"
            style="float:right;"
            v-show="isShowSearch"
            @click="searchVolumesInput()"
            >{{ $t("alarms.common.search") }}</Button
          >
        </Row>
        <Table
          :no-data-text="$t('common.noData')"
          ref="selection"
          :columns="columns"
          :loading="loading"
          :data="queryAccountVolumesData"
          :height="400"
          @on-selection-change="getSelection"
        ></Table>
      </Form>
      <div slot="footer">
        <Button @click="handleReset('volumeForm')">{{
          $t("permission_configuration_management.common.cancel")
        }}</Button>
        <Button
          type="primary"
          @click="handleSubmit('volumeForm')"
          :loading="addloading"
          :disabled="isDisable"
          >{{
            $t("permission_configuration_management.common.confirm")
          }}</Button
        >
      </div>
    </Modal>
    <table-volumes
      ref="tableVolumesChild"
      :getAccountType="getAccountType"
    ></table-volumes>
  </div>
</template>

<script>
import { getCookie } from "../../../utils/cookieUtil";
import TableVolumes from "@/components/ai_monitor/application_configuration/TableVolumes";
var tableVolumes = TableVolumes;
export default {
  name: "AddVolumes",
  components: {
    TableVolumes
  },
  props: ["getAccountType"],
  data() {
    return {
      accountType: "",
      instanceId: "",
      accountTypeList: [],
      singleAccount: false,
      volumeForm: {
        accountTypeSearchKey: "",
        account: [],
        region: "",
        tags: ""
      },
      accountList: [],
      regionList: [],
      selection: [],
      modal: false,
      isDisable: true,
      modalLoading: true,
      loading: false,
      isShowSearch: false,
      addloading: false,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("permission_configuration_management.group.name"),
          key: "name"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.instanceID"
          ),
          key: "instanceId"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.deviceName"
          ),
          key: "deviceName"
        },
        {
          title: this.$t("permission_configuration_management.group.volumeID"),
          key: "volumeAwsId"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.diskStorage"
          ),
          key: "capacity"
        },
        {
          title: this.$t("permission_configuration_management.group.type"),
          key: "type"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.readingSpeed"
          ),
          key: "iops"
        },
        {
          title: this.$t(
            "permission_configuration_management.group.encryption"
          ),
          key: "encrypted"
        },
        {
          title: this.$t("permission_configuration_management.group.region"),
          key: "region"
        },
        {
          title: this.$t("permission_configuration_management.group.status"),
          key: "stateName"
        }
      ],
      ruleValidate: {
        accountTypeSearchKey: [
          {
            required: true,
            message: this.$t('aiMonitor.selectCloudPlatform'),
            trigger: "change",
            type: "number"
          }
        ],
        account: [
          {
            required: true,
            message: this.$t('aiMonitor.selectAccount'),
            trigger: "change",
            type: "array"
          }
        ],
        region: [
          { required: true, message: this.$t('aiMonitor.selectRegion'), trigger: "change" }
        ]
      },
      queryAccountVolumesData: [],
      newQueryAccountVolumesDataList: []
    };
  },
  methods: {
    // 父组件调用子组件table内的方法
    queryVolumesByGroupId() {
      this.$refs.tableVolumesChild.queryVolumesByGroupId();
    },
    // 云平台
    queryCloudPlatforms: function() {
      this.$api.account
        .queryCloudPlatformsMSP("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountTypeList = res.data;
        });
    },
    // 切换云平台
    changeAccountTypeSearchKey: function() {
      this.volumeForm.account = [];
      this.volumeForm.region = "";
    },
    handleShowAdd() {
      // 清空表格
      this.modal = true;
      this.queryAccountVolumesData = [];
      this.isShowSearch = true;
      // this.selectAccountByCloudPlatform();
      this.selectAccount();
    },
    //查询账号
    selectAccountByCloudPlatform: function() {
      //   if (this.volumeForm.accountTypeSearchKey == undefined) {
      //     return;
      //   }
      this.$api.groupAccountRelation
        .getAccountByGroupIdAndCloudPlatform({
          groupId: this.$route.query.id,
          accountType: this.getAccountType
        })
        .then(res => {
          this.accountList = res.data;
        });
    },
    // 查询账户
    selectAccount: function() {
      this.$api.account
        .queryAccountsByCloudType("userName", getCookie(global.cookieName))
        .then(res => {
          this.accountList = res.data;
          for (var i = 0; i < this.accountList.length; i++) {
            this.accountList[i].name =
              this.accountList[i].name +
              "(" +
              this.accountList[i].accountTypeName +
              ")";
          }
        });
    },
    selectAccountAll() {
      this.volumeForm.account = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.volumeForm.account.push(item.id);
        });
      } else {
        this.volumeForm.account = [];
      }
    },
    // 切换账户
    changeAccount: function(val) {
      if (this.volumeForm.account.length == 0) {
        return;
      }
      // 清空表格
      this.queryAccountVolumesData = [];
      this.volumeForm.region = "";
      this.isShowSearch = true;
      if (val.length === this.accountList.length && val.length != 0) {
        this.singleAccount = true;
      } else {
        this.singleAccount = false;
      }
      // this.$api.account
      //   .queryAccountRegionsByAccountIds("accountIds", this.volumeForm.account)
      //   .then(res => {
      //     this.regionList = res.data;
      //   });
      this.$api.account
        .queryAccountRegions("accountId", this.volumeForm.account)
        .then(res => {
          this.regionList = res.data;
        });
    },
    // 切换存储区域
    changeRegion: function() {
      this.queryAccountVolumesData = [];
      this.isShowSearch = true;
    },
    getState: function(stateStr) {
      for (var i = 0; i < this.state.length; i++) {
        if (stateStr == this.state[i]) {
          return i;
        }
      }
      return -1;
    },
    // 当前选择checkbox
    getSelection: function(selection) {
      this.selection = selection;
      // 清空数组
      this.newQueryAccountVolumesDataList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableQueryAccountVolumesDataCopy = new Object();
        TableQueryAccountVolumesDataCopy.awsZone = this.selection[i].awsZone;
        TableQueryAccountVolumesDataCopy.instanceId = this.selection[
          i
        ].instanceId;
        TableQueryAccountVolumesDataCopy.deviceName = this.selection[
          i
        ].deviceName;
        TableQueryAccountVolumesDataCopy.capacity = this.selection[i].capacity;
        TableQueryAccountVolumesDataCopy.encrypted = this.selection[
          i
        ].encrypted;
        TableQueryAccountVolumesDataCopy.state = this.selection[i].state;
        TableQueryAccountVolumesDataCopy.iops = this.selection[i].iops;
        TableQueryAccountVolumesDataCopy.name = this.selection[i].name;
        TableQueryAccountVolumesDataCopy.region = this.selection[i].region;
        TableQueryAccountVolumesDataCopy.type = this.selection[i].type;
        TableQueryAccountVolumesDataCopy.volumeAwsId = this.selection[
          i
        ].volumeAwsId;
        TableQueryAccountVolumesDataCopy.accountId = this.selection[
          i
        ].accountId;
        this.newQueryAccountVolumesDataList.push(
          TableQueryAccountVolumesDataCopy
        );
      }
      // 选了数据 可以点击下一步
      if (this.newQueryAccountVolumesDataList.length == 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    // 点击查询
    searchVolumesInput: function() {
      this.loading = true;
      // 根据AccountId查询卷列表
      this.$api.brokerSummary
        .queryDisksByGroup({
          applicationId: this.$route.query.id,
          alertRuleName: this.$route.query.alertRuleName,
          region: this.volumeForm.region,
          accountIds: this.volumeForm.account,
          tags: this.volumeForm.tags
        })
        .then(res => {
          this.queryAccountVolumesData = res.data;
          this.loading = false;
        });
    },
    // 添加
    handleSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 增加
          this.addloading = true;
          this.$api.brokerSummary
            .createByapplicationDiskRelation({
              alertRuleName: this.$route.query.alertRuleName,
              applicationId: this.$route.query.id,
              volumeDTOS: this.newQueryAccountVolumesDataList
            })
            .then(res => {
              setTimeout(() => {
                tableVolumes.methods.showAllVolume();
                this.$refs[name].resetFields();
                this.modalLoading = false;
                this.$nextTick(() => {
                  this.modalLoading = true;
                });
                this.$Message.success(this.$t('common.addSuccess'));
                this.queryAccountVolumesData = [];
                this.newQueryAccountVolumesDataList = [];
                this.accountList = [];
                this.regionList = [];
                this.modal = false;
                this.addloading = false;
                this.isDisable = true;
                this.singleAccount = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.modalLoading = false;
          setTimeout(() => {
            this.modalLoading = true;
          }, 0);
          this.$Message.error(this.$t('common.addFail'));
        }
      });
    },
    // 取消
    handleReset: function(name) {
      this.isDisable = true;
      this.modal = false;
      this.singleAccount = false;
      this.accountList = [];
      this.regionList = [];
      this.queryAccountVolumesData = [];
      this.newQueryAccountVolumesDataList = [];
      this.$refs[name].resetFields();
    }
  }
};
</script>

<style scoped>
/*volumes*/
.volumes {
  width: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/AddVolumes.vue